import { Row, Col, Input, Button } from 'reactstrap';

import { useFormik } from 'formik';

import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useDispatch } from 'react-redux';

import { TagSearchFilters } from 'types/tag/TagTypes';
import { setPageFilters } from 'slices/tags/reducer';

interface TagSearchFormProps {
  _isDarkMode?: boolean;
  onSubmit: (value: TagSearchFilters) => void;
}

const TagSearchForm = ({
  _isDarkMode = false,
  onSubmit,
}: TagSearchFormProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const TagsState = useSelector((state: RootState) => state.Tags);
  const { PageFilters } = TagsState;

  const formik = useFormik({
    initialValues: PageFilters,
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(setPageFilters(values));
      onSubmit(values);
    },
  });
  return (
    <form onSubmit={formik.handleSubmit} data-testid="tagSearchForm">
      <Row>
        <Col md={8} lg={3} className="col-xxl-3 px-2 mx-1">
          <div className={`search-box me-2 mb-2 `}>
            <Input
              type="text"
              name="tagName"
              placeholder={t('Tag Name')}
              value={formik.values.tagName || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{ height: 38 }}
              maxLength={50}
              data-testid="search-form-tagName"
            />
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </Col>

        <Col md={2} lg={2} className="col-xxl-1">
          <Button
            color="success"
            type="submit"
            outline
            data-testid="search-form-btn-submit"
          >
            {t('Search')}
          </Button>
        </Col>

        {/* <Col sm={4} className="col-xxl-1"></Col> */}
      </Row>
    </form>
  );
};
export default TagSearchForm;
